<template>
    <div name="contract-info" class="wrapper">
        <loading v-if="isLoading" />
        <init 
            v-if="contractStep === 0"
            @goContract="goContract"
            @skip="skip"
            :duplicateDelegation="duplicateDelegation" 
        />
        <input-contract 
            style="box-sizing: border-box;"
            v-if="contractStep === 1"
            @closeContract="closeContract"
            @next="nextContract"
        />
        <contract 
            v-if="contractStep === 2"
            @onClose="closeContract"
            @next="nextContract"
        />
        <add-id 
            v-if="contractStep === 3"
            @onClose="closeContract"
            @next="nextContract"
            @prev="prevContract"
        />
        <addition-info 
            v-if="contractStep === 4"
            @next="nextContract"
            @onClose="closeContract"
            @submit="submit"
        />
        <complete-contract 
            :duplicateDelegation="duplicateDelegation"
            v-if="contractStep === 5"
            @completeContract="completeContract"
        />   
        <div class="page" v-if="error">
            <error-modal 
                :error="error"
                @onClose="onErrorModalClose"
            />
        </div>


    </div>
</template>

<script>
import focusBackground from '@/components/directives/focusBackground';
import Steps from '@/components/molecules/Steps'
import TextLabel from '@/components/atoms/TextLabel';
import {mapState} from 'vuex';
import BottomButton from '@/components/atoms/BottomButton';
import PageFooter from '@/components/molecules/PageFooter';

import InputContract from '@/components/organisms/contract/InputContract';
import Contract from '@/components/organisms/contract/ContractNew'
import AddId from '@/components/organisms/contract/AddId';
import Constant from '@/constant';
import cookies from '@/utilities/cookie.js';
import ErrorModal from '@/components/modals/ErrorModal';
import Loading from '@/components/molecules/Loading';
import ConfirmModal from '@/components/modals/ConfirmModal';
import Init from '@/components/organisms/contract/Init';
import AdditionInfo from '@/components/organisms/contract/AdditionInfo';
import CompleteContract from '@/components/organisms/contract/CompleteContract';

export default {
    name: 'contractInfo',
    computed: mapState(['delegateWithAddition', 'pre_delegation_info', 'draftProfile']),
    data: function()
    {
        return {
            contractStep: 0,
            duplicateDelegation: false, // 재진시 위임청구 여부 
            token: null,
            isLoading: false,
            error: null,
        }
    },
    directives: {
        focusBackground
    },
    components: {
        Steps,
        TextLabel,
        BottomButton,
        PageFooter,
        InputContract,
        Contract,
        AddId,
        Loading,
        ErrorModal,
        ConfirmModal,
        Init,
        AdditionInfo,
        CompleteContract
    },
    mounted: function()
    {
        window.addEventListener("popstate", this.handleBack);

        ChannelIO('shutdown')              

        if(!this.pre_delegation_info.is_loading)
        {   
            this.$router.push({path:"/"})
        }
        this.topFunction();

        this.token = cookies.getLocalStorage("access_token");
        if(this.token === null || this.token === undefined || this.token === '')
        {
            this.token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'register'}})
        }
        else
        {
            
            if(this.pre_delegation_info.is_delegated)
            {
                // 이미 
                if(this.pre_delegation_info.expired_at)
                {
                    
                    let cur = new Date();
                    let expire = new Date(this.pre_delegation_info.expired_at);
                    expire.setDate(expire.getDate() - 30);
                    if(cur >= expire)
                    {
                        this.contractStep = 0;
                        this.duplicateDelegation = true;  // 만료 
                    }
                    expire = new Date(this.pre_delegation_info.expired_at);
                    expire.setDate(expire.getDate());
                    if(cur > expire)
                    {
                        this.duplicateDelegation = false;
                    }
                    else
                    {
                        this.contractStep = 5;
                    }
                }
                
            }
        }
    },
    beforeUnmount() {
        window.removeEventListener("popstate", this.handleBack);
    },
    methods: {
        handleBack: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
        },
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        goContract: function()
        {
            this.contractStep = 1;
        },
        closeContract: function()
        {
            this.contractStep = 0;
        },
        prevContract: function(step)
        {
            this.contractStep = step
        },
        nextContract: function(step)
        {
            this.contractStep = step;
        },
        submit: function()
        {
            this.isLoading = true;

            this.$store.dispatch(Constant.SAVE_DELEGATE_WITH_ADDITION, {profile_id: this.pre_delegation_info.profile_id, token: this.token})
                .then(() => {
                    this.isLoading = false;
                    this.contractStep = 5;
                })
                .catch((err) => {
                    this.error = err;
                    this.isLoading = false;
                })
            

        },
        completeContract: function()
        {
            this.duplicateDelegation = false;
            this.$router.push({path: '/card'})
            
            // this.isLoading = true;
            // this.$store.dispatch(Constant.TEMP_SAVE_DIABETES, {token: this.token})
            //     .then((res) => {
            //         this.status.staging_data_index = res.staging_data_index;
            //         // read data
                    
            //         this.$store.dispatch(Constant.FETCH_TEMP_SAVE_DIABETES,  {name: this.body.profile.name, registration_number: this.body.profile.registration_number, token: this.token})
            //             .then((res) => {
            //                 this.isLoading = false;
            //                 if(res.premedical_info != null)
            //                 {
            //                     this.body.premedical_info = res.premedical_info;
            //                 }

            //                 if(res.delegation_info != null)
            //                 {
            //                     this.body.delegation_info = res.delegation_info;
            //                 }
            //                 this.duplicateDelegation = false;
            //                 this.$router.push({path: '/card'})
                            
            //             })
            //             .catch((err) => {
            //                 //예외처리 (3)
            //                 this.error = err.message;
            //                 this.isLoading = false;
            //             })
            //         // 
            //     })
            //     .catch((err) => {
            //         this.error = err.message;
            //         this.isLoading = false;
            //     })      
        },
        skip: function()
        {
            this.isLoading = true;
            this.duplicateDelegation = false;

            this.$store.dispatch(Constant.SAVE_DELEGATE_FALSE, {profile_id: this.pre_delegation_info.profile_id, token: this.token})
                .then(() => {
                    this.$router.push({path: '/card'})
                })
                .catch((err) => {
                    this.error = err;
                    this.isLoading = false; 
                })
            
            // this.body.delegation_info.agreement_delegate = false;
            // this.body.delegation_info.agreement_personal_info = false;
            // this.body.delegation_info.agreement_personal_identification_info = false;

            // file 비우기
            // this.files.premedical_files = [];
            // this.files.signature_file = null;
            // this.files.delegation_docs_file = null;
            // this.files.id_card_file = null;


            // this.$store.dispatch(Constant.TEMP_SAVE_DIABETES, {token: this.token})
            //     .then((res) => {
            //         this.isLoading = false;
            //         this.$router.push({path: '/card'})
            //     })
            //     .catch((err) => {
            //         this.error = err.message;
            //         this.isLoading = false;
            //     })

        },
        onErrorModalClose: function()
        {
            this.error = null;
        },
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        
    }
    .page {
        width: 100%;
        position: fixed;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
            
        }
        
    }



    .info-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: -0.42px;
    }
    .info-color-text {
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.42px;
    }
    .row {
        text-align: center;
    }








</style>


// WEBPACK FOOTER //
// src/page/ContractInfo.vue